import { msg } from 'gt-react';
import { BuildingIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const CompanyLocationsPage = lazyRouteComponent(
  () => import('./CompanyLocationsPage'),
  'CompanyLocationsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/company-locations',
  staticData: {
    app: {
      nav: {
        label: msg('Company Locations', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <BuildingIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: CompanyLocationsPage,
  loader: () => ({
    crumb: msg('Company Locations', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
